import React from 'react'
import { useHistory } from 'react-router-dom'
import { useAuth } from '../../../contexts/AuthContext';
import { ENDPOINT } from '../../../constants';
import { FetchApi } from '../../../api/fetch';

function Telegram() {
    const history = useHistory()
    const { setIsLoadingOverlayDisplay, getUserJWT } = useAuth()

    const downloadAttendance = async () => {
        setIsLoadingOverlayDisplay(true);

        try {
            const userJWT = await getUserJWT();
            const blob = await FetchApi({
                endpoint: `${ENDPOINT.BASE_PROXY}/telegram-stats`,
                method: "GET",
                JWT: userJWT,
                format: 'blob'
            });

            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            a.download = 'csv_files.zip'; // Matches backend filename
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);

        } catch (error) {
            console.error('Error downloading stats:', error);
        } finally {
            setIsLoadingOverlayDisplay(false);
        }
    };

    return (
        <div className='px-9'>
            <div className="mt-4 flex flex-row items-center justify-between flex-col sm:flex-row">
                <div className="w-auto">
                    <h1 className="font-semibold text-3xl text-left mt-8 mb-8">
                        Telegram Bot Admin Panel
                    </h1>
                </div>
            </div>
            <div className="min-h-[70vh] flex items-center justify-center p-6">
                <div className="w-full max-w-md space-y-6">
                    {/* Send New Message Button */}
                    <button onClick={() => history.push("/dashboard/telegram/send-message")} className="w-full p-[1px] bg-gradient text-white font-medium rounded-xl">
                        <span className="bg-kyzzen-primary block p-4 rounded-xl">
                            Send New Message
                        </span>
                    </button>

                    {/* See Message History Button */}
                    <button onClick={() => history.push("/dashboard/telegram/messages")} className="w-full p-[1px] bg-gradient text-white font-medium rounded-xl">
                        <span className="bg-kyzzen-primary block p-4 rounded-xl">
                            See Message History
                        </span>
                    </button>

                    {/* Download Bot Stats Button */}
                    <button onClick={downloadAttendance} className="w-full py-4 px-6 bg-gradient text-kyzzen-primary  font-medium rounded-xl transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-50 flex items-center justify-center gap-3 shadow-lg">
                        <span>Download Bot Stats</span>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3" />
                        </svg>
                    </button>
                </div>
            </div>
        </div>

    )
}

export default Telegram